import React, { useCallback, useMemo, useState } from 'react';
import AsyncDropdown from '../../../../components/AsyncDropdown';
import { useSelector } from 'react-redux';
import { useFetchOMSProducts } from '../../custom-hooks/useFetchOMSProducts';
import { useTranslation } from 'react-i18next';
import { debounce } from '../../../../utils/debounce';
import { arrayToDropdownOptions } from '../../../../utils/sms/arrayToDropdownOptions';

const ProductsDropdown = (props) => {
  const { selectedProducts, setSelectedProducts } = props;
  const { t } = useTranslation();
  const productsMap = useSelector(
    (state) => state?.allProducts?.productsMap || {}
  );
  const vanNoOptions = useMemo(
    () => arrayToDropdownOptions(Object.keys(productsMap)),
    [productsMap]
  );

  useFetchOMSProducts();

  const fetchOptions = useCallback(
    debounce(async (inputValue) => {
      if (inputValue.length > 2) {
        try {
          const filteredOptions = vanNoOptions?.filter((vanNo) =>
            vanNo.value.includes(inputValue)
          );
          return filteredOptions;
        } catch (e) {
          console.log(e);
        }
      }
    }),
    [vanNoOptions]
  );

  const handleChange = (options) => {
    setSelectedProducts(options);
  };

  return (
    <div className="w-auto">
      <AsyncDropdown
        onChange={handleChange}
        value={selectedProducts}
        width={'100%'}
        disabled={false}
        isMultiSelect={true}
        fetchOptions={fetchOptions}
        placeholder={t('Search')}
        backgroundColor={'#F0F0F0'}
        optionColor={'#FFF'}
      />
    </div>
  );
};

export default ProductsDropdown;
